import { ApiClient } from './client'

// --- Types ---

export interface ApprovalDetails {
  id: string
  purpose: string
  subject_type: string
  subject_id: string
  requested_by_name: string
  requested_at: string
  expires_at: string
}

export interface ApprovalResult {
  status: string
  purpose: string
  subject_type: string
  subject_id: string
}

// --- API factory ---

export function approvalsApi(api: ApiClient) {
  return {
    validate: (token: string) =>
      api.get<ApprovalDetails>(`/approvals/validate?token=${encodeURIComponent(token)}`),

    consume: (token: string) =>
      api.post<ApprovalResult>('/approvals/consume', { token }),
  }
}
